import React from 'react'

import { Button } from 'primereact/button'
import { Panel, PanelPassThroughOptions } from 'primereact/panel'

import { EinvoiceValidationresult } from '../../../../data/models'
import { getResultTranslation } from '../../utils'
import { RoundedStatusIcon } from '../rounded-status-icon'

type Props = {
  results?: EinvoiceValidationresult[]
  status: EinvoiceValidationresult['Level']
  title: string
  onInfoClick?: (result: EinvoiceValidationresult) => void
}

export const ResultPanel: React.FC<Props> = ({
  results,
  status,
  title,
  onInfoClick,
}) => {
  if (!results || results.length === 0 || !status) return null

  const header = (
    <div className="flex align-items-center gap-4">
      <RoundedStatusIcon status={status} />

      <h4 className="font-bold">{title}</h4>
    </div>
  )

  return (
    <Panel
      header={header}
      toggleable
      className="mx-auto mb-5"
      style={{ maxWidth: '600px' }}
      pt={panelPassThroughOptions}
    >
      {results.map((result, index) => {
        return (
          <div
            key={index}
            className="border-top-1 border-gray-100 py-3 px-5 flex align-items-center gap-4"
          >
            <RoundedStatusIcon status={result.Level} />

            <div className="flex-grow-1">
              <h4 className="my-1 overflow-wrap-anywhere">
                {getResultTranslation('title', result)}
              </h4>
              <p
                className="m-0 text-gray-400 overflow-wrap-anywhere"
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {getResultTranslation('description', result)}
              </p>
            </div>
            {onInfoClick && (
              <Button
                icon="pi pi-info-circle"
                className="flex-shrink-0"
                rounded
                text
                aria-label="Info"
                onClick={() => onInfoClick(result)}
              />
            )}
          </div>
        )
      })}
    </Panel>
  )
}

const panelPassThroughOptions: PanelPassThroughOptions = {
  root: {
    className:
      'bg-white overflow-hidden border-round-3xl border-1 border-gray-100',
  },
  header: { className: 'bg-white border-none py-0 px-5' },
  content: {
    className: 'border-none p-0',
  },
  toggler: {
    className: 'bg-white text-primary p-2',
  },
}
